<template>
  <SoPageWithRightSidePanel v-model="current.isSidePanelCollapsed">
    <SoContainer fluid>
      <SoRow>
        <SoCol>
          <ComplaintsTimelineWidget />
        </SoCol>
      </SoRow>
    </SoContainer>
    <template #sidePanel>
      <CustomerAccountInfoPanel></CustomerAccountInfoPanel>
    </template>
    <template #sidePanelRail>
      <CustomerAccountInfoRail></CustomerAccountInfoRail>
    </template>
  </SoPageWithRightSidePanel>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import SoContainer from "@/components/SoContainer.vue"
  import SoPageWithRightSidePanel from "@/components/templates/SoPageWithRightSidePanel.vue"
  import CustomerAccountInfoPanel from "../overview/CustomerAccountInfoPanel.vue"
  import CustomerAccountInfoRail from "../overview/CustomerAccountInfoRail.vue"
  import SoRow from "@/components/SoRow.vue"
  import SoCol from "@/components/SoCol.vue"
  import ComplaintsTimelineWidget from "./widgets/ComplaintsTimelineWidget.vue"

  export default defineComponent({
    components: {
      SoContainer,
      SoPageWithRightSidePanel,
      CustomerAccountInfoPanel,
      CustomerAccountInfoRail,
      SoRow,
      SoCol,
      ComplaintsTimelineWidget,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
      }
    },
    mounted() {
      this.current.seenOpenComplaints = true
      this.current.isSidePanelCollapsed = true
    },
  })
</script>
